import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)

// Elite Membership animation constants
export const MILESTONE_PCT = [0, 33, 66] as const
export const FILL_START = 0
export const FILL_AFTER_MILESTONE_1 = 33
export const FILL_AFTER_MILESTONE_2 = 67

export const TIMELINE_TO_1 = {
    START_TO_M1_FILL_AT_MS: 800,
    M1_REACHED_AT_MS: 1000,
    CONFETTI_AT_MS: 1400,
} as const

export const TIMELINE_TO_2 = {
    START_TO_M2_FILL_AT_MS: 1200,
    M1_REACHED_AT_MS: 1300,
    M2_REACHED_AT_MS: 1600,
    CONFETTI_AT_MS: 2000,
} as const

export const MESSAGE_INTERVAL_MS = 3200
export const SCROLL_DURATION_MS = 500

// Shared animated card (loader / fallback / main UI) constants
export const HEIGHT_TRANSITION_MS = 500
export const CARD_BORDER_OFFSET = 2
export const STATE_CARD_HEIGHT = 132

export const LOADER_MESSAGES = [
    'Updating Elite progress',
    'Almost there, verifying your Elite progress',
    'Your trip is moving you closer to Elite',
] as const

export const FALLBACK_TEXT = 'This booking brings you closer to Elite. See your updated progress on the loyalty page.'
export const LOADER_ARIA_LABEL = 'Updating Elite progress'
export const FALLBACK_CTA_LABEL = 'View Elite progress'

const CONFIRMATION_LANDED_AT_KEY = 'elite_confirmation_landed_at'

/** Persists the first time the user lands on confirmation for this trip. */
export function getOrCreateConfirmationLandedAt(tripId: string): number {
    const now = Date.now()
    if (typeof window === 'undefined' || !tripId) return now
    try {
        const raw = window.localStorage.getItem(CONFIRMATION_LANDED_AT_KEY)
        if (raw) {
            const parsed = JSON.parse(raw) as { tripId?: string; landedAt?: number }
            if (parsed?.tripId === tripId && typeof parsed.landedAt === 'number' && parsed.landedAt > 0) {
                return parsed.landedAt
            }
        }
        window.localStorage.setItem(CONFIRMATION_LANDED_AT_KEY, JSON.stringify({ tripId, landedAt: now }))
    } catch { }
    return now
}

const SHORT_DATE_FORMATS = ['DD-MM-YYYY', 'YYYY-MM-DD'] as const

export function formatShortDate(date: string | null | undefined) {
    if (!date) return ''

    for (const format of SHORT_DATE_FORMATS) {
        const parsed = dayjs(date, format, true)
        if (parsed.isValid()) {
            return parsed.format('D MMM YYYY')
        }
    }

    const parsed = dayjs(date)
    return parsed.isValid() ? parsed.format('D MMM YYYY') : ''
}

/** Earned Loyalty Post-booking constants */
export function getEliteTextPostBooking(
    viewAllotmentDate?: string | null,
    viewExpiryDate?: string | null
) {
    return {
        loginToCheckStatusText: 'Log in to check status',
        nonLoggedInWithOneBooking: 'You’re almost there! Login and complete 1 more booking to unlock membership benefits',
        oneBookingComplete: 'You’re almost there! Complete 1 more booking to unlock membership benefits',
        twoBookingsComplete: 'Your membership benefits will unlock soon',
        twoBookingsCompleteWithAllotmentDate: `Your membership will unlock on ${formatShortDate(viewAllotmentDate)}`,
        trackerExpiringSoonWithExpiryDate: `You’re almost there! Complete next booking before ${formatShortDate(viewExpiryDate)} to unlock membership benefits`,
    }
}

export const ELITE_UNLOCK_SOON_MODAL_DEFAULTS = {
    benefitLeft: 'Flight date change at ₹9',
    benefitRight: '1% SuperCoins upto 100',
    footerLine: 'and much more!',
}

export function getUnlockSoonTextPostBooking(viewAllotmentDate?: string | null) {
    return viewAllotmentDate
        ? `Your membership will unlock on ${formatShortDate(viewAllotmentDate)}`
        : 'Your membership benefits will unlock soon'
}

/** Fallback when offerJson `eliteUnlockSoonContent` is unavailable. */
export const ELITE_BENEFITS = [
    'Flight date change at ₹9',
    'Min. 20% off on Hotels',
    'Min. ₹5,000 off on Holidays',
    'Earn up to 100 Supercoins',
] as const
